import { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Stripe } from '@stripe/stripe-js/types/stripe-js';
import { STRIPE_PUBLIC_KEY } from '../../environment/environment';

const useStripeObject = (): PromiseLike<Stripe | null> | null => {
    const [stripePromise, setStripeObject] = useState<PromiseLike<Stripe | null> | null>(null);

    useEffect(() => {
        const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
        setStripeObject(stripePromise);
    }, []);

    return stripePromise;
};
export default useStripeObject;
